<template>
<div class="clum2right right">
  <div id="content_block" class="right">
    <div class="account_icon right"> </div>
    <div v-if="isReadOnly" class="content_title right">پروفایل من</div>
    <div v-else class="content_title right">پروفایل من > ویرایش</div>
    <div id="content_main" class="right">
      <div class="pure-form pure-form-aligned">
        <fieldset>

          <div class="pure-control-group" style="line-height: 50px;">
            <label for="email">آدرس ایمیل</label>
            <input id="email" v-bind:class="{ 'pure-input-2-3':true , inputread: isReadOnly }" type="email" placeholder="username@domain.com" v-model="strEmail" v-bind:readonly="isReadOnly" v-bind:disabled="!isReadOnly">
          </div>

          <div class="pure-control-group" style="line-height: 50px;">
            <label for="name">نام</label>
            <input id="name" v-bind:class="{ 'pure-input-2-3':true , inputread: isReadOnly }" type="text" v-model="strFirstName" placeholder="نام" v-bind:readonly="isReadOnly">
          </div>

          <div class="pure-control-group" style="line-height: 50px;">
            <label for="name">نام خانوادگی</label>
            <input id="name" v-bind:class="{ 'pure-input-2-3':true , inputread: isReadOnly }" type="text" v-model="strLastName" placeholder="نام خانوادگی" v-bind:readonly="isReadOnly">
          </div>

          <div class="pure-control-group" style="line-height: 50px;">
            <label for="name">تلفن</label>
            <input id="name" v-bind:class="{ 'pure-input-2-3':true , inputread: isReadOnly }" type="text" v-model="phone" placeholder="+886-3-5525279" v-bind:readonly="isReadOnly">
          </div>

          <div class="pure-controls" style="float: left;">
            <button v-show="isReadOnly" type="reset" class="button-warning pure-button pure-button-primary" style="width: 160px;" @click="edit()">ویرایش پروفایل</button>
            <button v-show="isReadOnly" type="submit" class="button-warning pure-button pure-button-primary" style="width: 160px;" @click="changepsw()">تغییر رمزعبور</button>
            <button v-show="!isReadOnly" type="reset" value="Reset" class="button-warning pure-button pure-button-primary" style="width: 160px;" @click="cancel()">لغو</button>
            <button v-show="!isReadOnly" type="submit" class="button-warning pure-button pure-button-primary" style="width: 160px;" @click="modifyaccount()">ذخیره سازی</button>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</div>
</template>
<script>
/*jshint esversion: 6 */
import {
  getDataUrl
} from '../../../tools/getUrl.js';
import router from '../../../router.js';
export default {
  data: function() {
    return {
      isReadOnly: true,
      accountid: '',
      strFirstName: '',
      strLastName: '',
      strEmail: '',
      phone: ''
    };
  },
  methods: {
    edit: function() {
      // router.replace('/Main/Profile/Edit');
      this.isReadOnly = false;
    },
    changepsw: function() {
      router.replace('/Main/Changepsw');
    },
    cancel: function() {
      this.isReadOnly = true;
      this.initData();
    },
    modifyaccount: function() {
      var obj = {
          api: 'modify_account',
          account_id: sessionStorage.getItem('accountid'),
          passwd: sessionStorage.getItem('psw'),
          first_name: this.strFirstName,
          last_name: this.strLastName,
          phone: this.phone
        },
        url = getDataUrl(obj);
      this.$http.get(url).then((response) => {
        // success callback
        if (response.data > 0) {
          this.isReadOnly = true;
          sessionStorage.setItem('first_name', this.strFirstName);
          // router.replace('/Main/Profile');
        }
      }, (response) => {
        // error callback
      });
    },
    initData() {
      var obj = {
          api: 'get_account',
          account_id: sessionStorage.getItem('accountid'),
          output: 'json'
        },
        url = getDataUrl(obj);
      this.$http.get(url).then((response) => {
        // success callback
        var strResponse = response.data.toString().replace(/\r\n|\n/g, ""),
          obj = JSON.parse(strResponse).account[0];
        this.accountid = obj.account_id !== 'null' ? obj.account_id : '';
        this.strFirstName = obj.first_name !== 'null' ? obj.first_name : '';
        this.strLastName = obj.last_name !== 'null' ? obj.last_name : '';
        this.phone = obj.phone !== 'null' ? obj.phone : '';
        this.strEmail = sessionStorage.getItem('email');
      }, (response) => {
        // error callback
      });
    }
  },
  mounted() {
    this.initData();
  }
};
</script>
<style scoped>
.inputread {
  background-color: white !important;
  color: black !important;
  border: 0px !important;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// ProfileDetail.vue?175b033d